import { api } from '../../shared/api';

export type PublicGalleryKind = 'stay' | 'daycare';

export interface PublicPhoto {
  readonly id: string;
  readonly downloadUrl: string;
  readonly fileName: string;
}

export const publicGalleryQueryKey = (kind: PublicGalleryKind, code: string) => ['public-gallery', kind, code] as const;
export const publicGalleryCacheTime = 4 * 60 * 1000;

export async function loadPublicGallery(kind: PublicGalleryKind, code: string): Promise<{ label: string; photos: PublicPhoto[] }> {
  if (kind === 'daycare') {
    const gallery = await api.publicDaycareGallery(code);
    return { label: 'Galeria de guarderia', photos: gallery.photos };
  }
  const gallery = await api.publicGallery(code);
  return { label: `Galeria #${gallery.shortId}`, photos: gallery.photos };
}
